<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.notification.editor')"></breadcrumb>
        <div class="text-right pr-3 py-3">
             <b-button class="ml-auto" variant="info" size="sm" @click="create()"
                    v-if="permissions.createNotificationsEditor">{{$t('button.create')}}
            </b-button>
        </div>
             
        <div class="content">
                
            <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

            <div class="container-fluid">
                <div class="card">
                    <div class="card-header bg-light">{{$t('form.notification.editor')}}</div>
                    <div class="card-body p-0">
                        <table class="table table-hover table-bordered">
                            <thead>
                                <tr>
                                    <th>{{$t('form.notification.nameText')}}</th>
                                    <th class="text-right">{{$t('form.notification.action')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in list" :key="index">
                                    <td class="text-capitalize">{{item.title}}</td>
                                    <td class="text-right">
                                        <b-button variant="info" size="sm" @click="edit(item.slug)"
                                            v-if="permissions.editNotificationsEditor">{{$t('button.edit')}}
                                        </b-button>
                                          <b-button variant="danger" size="sm" @click="deleteTemplate(item.slug)"
                                             v-if="permissions.deleteNotificationsEditor">{{$t('button.delete')}}
                                         </b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import summernote from '../../components/Summernote';

    export default {
        props: ["permissions"],
        components: {
            summernote
        },

        data() {
            return {
                alert: false,
                alertClass: null,
                alertMessage: null,

                isLoading: false,
                fullPage: true,
                toggle: 0,

                list: [],
            };
        },

        mounted() {
            if (!this.permissions.viewNotificationsEditor) {
                this.$router.push('/');
            }

            this.getNotificationTemplates();
        },

        methods: {
            edit(slug) {
                this.$router.push({
                    name: 'NotificationEditorEdit',
                    params: {
                        id: slug
                    }
                })
            },
            removeBySlug(arr, slug){
                    const requiredIndex = arr.findIndex(el => {
                        return el.slug === String(slug);
                    });
                    if(requiredIndex === -1){
                        return false;
                    };
                    return !!arr.splice(requiredIndex, 1);
            },
              async deleteTemplate(slug) {
                   const answer = window.confirm(this.$t('form.notification.deleteConfirm'));
                if(!answer){
                      return;
                  }
                  this.isLoading = true;
                 
                   try {
                    const response = await axios.delete("/api/notification/templates/"+slug);
                    this.removeBySlug(this.list, slug);
                    this.isLoading = false;
                    this.showAlert(response.data.message, 'success');
                } catch (error) {
                    console.log(error);
                }
            },

             create() {
                this.$router.push({
                    name: 'NotificationEditorCreate'
                })
            },
            
            /**
             * Show alert
             */
            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            /*
            * Get list of notification templates
            */
            async getNotificationTemplates(){
                this.isLoading = true;
                try {
                    const result = await axios.get("/api/notification/templates");
                    this.list = result.data;
                    this.isLoading = false;
                } catch (error) {
                    console.log(error);
                }
            }


        }
    };

</script>
